module.exports = __webpack_public_path__ + "static/img/pitch_blue.82a977d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pitch_blue.png
// module id = FInX
// module chunks = 94